import { BrowserRouter, Route, Routes } from 'react-router'
import { Home } from './home'

export const RoutingProvider = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  )
}
